import { ArrowUpRight, Instagram } from "lucide-react";
import { ScrollReveal, SectionLabel } from "./Reveal";
import { LINKS } from "@/constants/links";

// Mix of real Etia Media work (local images) and placeholder stills.
const tiles = [
  "/images/img-0373.jpg",
  "https://images.unsplash.com/photo-1582994254571-52c62d96ebab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxmaWxtbWFrZXIlMjBjYW1lcmElMjBsZW5zJTIwY3JlYXRpdmUlMjBhZ2VuY3klMjBzdHVkaW8lMjBkYXJrbmVzcyUyMHNoYWRvd3xlbnwwfHx8fDE3ODk1MDkyMDl8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1576280314550-773c50583407?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxmaWxtbWFrZXIlMjBjYW1lcmElMjBsZW5zJTIwY3JlYXRpdmUlMjBhZ2VuY3klMjBzdHVkaW8lMjBkYXJrbmVzcyUyMHNoYWRvd3xlbnwwfHx8fDE3ODk1MDkyMDl8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1614604858874-5354c8788d3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBjYW1lcmElMjBmaWxtJTIwZGlyZWN0b3IlMjB2aWRlbyUyMHByb2R1Y3Rpb24lMjBzdHVkaW98ZW58MHx8fHwxNzg5NTA5MjA5fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1746730921536-6123c87a074d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBicmFuZCUyMGZhc2hpb24lMjBtb2RlbCUyMGVkaXRvcmlhbCUyMHBvcnRyYWl0JTIwcGhvdG9ncmFwaHl8ZW58MHx8fHwxNzg5NTA5MjA5fDA&ixlib=rb-4.1.0&q=85",
  "/images/img-0372.jpg",
];

export const SocialSection = () => (
  <section data-testid="social-section" className="py-24 lg:py-32 bg-[#111111] border-y border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <ScrollReveal>
        <SectionLabel index="05" title="On Social" />
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
          <h2 className="font-display leading-[0.95] text-5xl sm:text-6xl lg:text-7xl">
            Follow the work.
          </h2>
          <a
            data-testid="social-follow-btn"
            href={LINKS.instagram}
            target={LINKS.instagram.startsWith("http") ? "_blank" : undefined}
            rel="noopener noreferrer"
            onClick={LINKS.instagram === "#" ? (e) => e.preventDefault() : undefined}
            className="group flex items-center gap-3 font-display text-sm tracking-[0.08em] border-b border-[#F2F0EB] pb-2 w-fit hover:gap-5 transition-all duration-300"
          >
            <Instagram className="w-4 h-4" />
            Instagram
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </ScrollReveal>

      <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
        {tiles.map((src, i) => (
          <ScrollReveal key={i} delay={i * 0.05}>
            <div
              data-testid={`social-tile-${i + 1}`}
              className="group relative aspect-square overflow-hidden border border-white/10"
            >
              <img
                src={src}
                alt="Etia Media on social"
                className="w-full h-full object-cover grayscale-[40%] group-hover:grayscale-0 group-hover:scale-110 transition-[transform,filter] duration-700"
              />
              <div className="absolute inset-0 bg-[#0A0A0A]/0 group-hover:bg-[#0A0A0A]/30 transition-colors duration-500 flex items-center justify-center">
                <Instagram className="w-6 h-6 text-[#F2F0EB] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
            </div>
          </ScrollReveal>
        ))}
      </div>

      <ScrollReveal delay={0.1}>
        <p className="mt-6 font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#55554F]">
          Real work mixed with stills — connect Instagram for a live auto-updating feed.
        </p>
      </ScrollReveal>
    </div>
  </section>
);
